<template>
    <div id="tab-5">
        <TabLabel
            text="Банковские данные"
            number="5"
            :isCompleted="tabCompleted"
            @edit="openCurrentTab"
            :isAdmin="isAdmin"
        />
        <ContainerSlot :isCompleted="tabActive === 'tab-5'" v-if="localData">
            <v-form @submit="addTab" id="form-tab-5">
                <div class="title">Банковские данные</div>
                <div class="input-container">
                    <div class="input-block">
                        <v-input
                            name=""
                            title="Расчетный счет"
                            rules="required"
                            v-model="localData.bank_payment_account"
                            :disabled="disabled"
                        />
                    </div>
                    <div class="input-block">
                        <v-input
                            name=""
                            title="Корреспондентский счет"
                            rules="required"
                            v-model="localData.bank_correspondent_account"
                            :disabled="disabled"
                        />
                    </div>
                    <div class="input-block">
                        <v-input
                            name=""
                            title="БИК"
                            rules="required"
                            v-model="localData.bank_identification_code"
                            :disabled="disabled"
                        />
                    </div>
                </div>
                <FileInput
                    max="10"
                    title="Скан справки об открытии счета в банке"
                    :error="fileInputError"
                    target="bank_files"
                    :items="stepData.bank_files"
                    :deleteFileById="deleteFileById"
                    @upload-file="uploadFile"
                    :disabled="disabled"
                />
            </v-form>

            <v-btn v-if="!hideButton" form="form-tab-5">{{ !tabCompleted ? "Далее" : "Сохранить" }}</v-btn>
        </ContainerSlot>
    </div>
</template>

<script>
import { fileUploader } from "../../services/mixins/file-uploader";

export default {
    name: "tab-5",
    components: {
        TabLabel: () => import("../UI/TabLabel"),
        ContainerSlot: () => import("../UI/ContainerSlot"),
        FileInput: () => import("../UI/FileInput")
    },
    $_veeValidate: {
        validator: "new"
    },
    mixins: [fileUploader],
    props: {
        tabCompleted: {
            required: true
        },
        deleteCompleteTab: Function,
        addCompleteTab: Function,
        saveStepData: Function,
        setEditTab: Function,
        tabActive: String,
        stepData: Object,
        hideButton: {
            default: false
        },
        disabled: {
            default: false
        },
        isAdmin: {
            default: false
        }
    },
    data() {
        return {
            localData: null
        };
    },
    created() {
        this.localData = { ...this.stepData };
    },
    watch: {
        tabActive(val) {
            if (val === "tab-5") {
                this.localData = { ...this.stepData };
            } else {
                this.saveStepData("stepData_5", this.localData);
            }
        }
    },
    methods: {
        openCurrentTab() {
            this.setEditTab("tab-5");
        },
        addTab() {
            if (!this.stepData.bank_files.length) {
                this.fileInputError = "Нужно вставить хотябы один скан";
            }
            this.validate().then(() => {
                if (!this.stepData.bank_files.length) {
                    this.fileInputError = "Нужно вставить хотябы один скан";
                    return;
                }
                this.addCompleteTab("tab-5", "stepData_5", this.localData);
            });
        }
    }
};
</script>

<style lang="scss">
#tab-5 {
}
</style>
